export const getASIntegratorTemplateScriptSrc = (devMode: boolean, devModeTemplateScriptBasePath?: string): string => {
  if (devMode) {
    // Default to "build/" if no base path provided
    if (!devModeTemplateScriptBasePath) {
      devModeTemplateScriptBasePath = "build/";
    }
    return `${devModeTemplateScriptBasePath}embeddables/embeddables.esm.js`;
  }
  return "https://storage.googleapis.com/sb-ui/springboard.esm.js";
};